import { Trans } from 'react-i18next';
import { PlayerApiKey, UserMenuOption } from './helper.type';
import {
  HourlySweepStatus,
  HourlySweepStatusColors,
} from '../pages/dashboard/dashboard.type';
import { SweepType } from '@inplay/models';
import { Language } from '../component/languageToggle/languageToggle.type';
import { GB } from 'country-flag-icons/string/3x2';

export const PlayerHeaderTitle = [
  {
    key: PlayerApiKey.Image,
    label: <Trans i18nKey="common.image" />,
  },
  {
    key: PlayerApiKey.Description,
    label: <Trans i18nKey="common.description" />,
  },
  {
    key: PlayerApiKey.GamingInMinute,
    label: <Trans i18nKey="common.totalInGamingRoomCurrent" />,
    sortable: true,
  },
  {
    key: PlayerApiKey.GamingOutSideMinute,
    label: <Trans i18nKey="common.totalOutGamingRoom" />,
    sortable: true,
  },
  {
    key: PlayerApiKey.TotalWithDrawals,
    label: <Trans i18nKey="playerHeaderTitle.aTMUse" />,
  },
  {
    key: PlayerApiKey.FirstEntered,
    label: <Trans i18nKey="common.firstEntered" />,
    sortable: true,
  },
  {
    key: PlayerApiKey.LastExited,
    label: <Trans i18nKey="common.lastExited" />,
    sortable: true,
  },
  {
    key: PlayerApiKey.HarmObserved,
    label: <Trans i18nKey="common.actions" />,
  },
];

export const AtmHeaderTitle = [
  {
    key: PlayerApiKey.Image,
    label: <Trans i18nKey="common.image" />,
  },
  {
    key: PlayerApiKey.Description,
    label: <Trans i18nKey="common.description" />,
  },
  {
    key: PlayerApiKey.TotalWithdraw,
    label: <Trans i18nKey="common.totalWithdrawals" />,
    sortable: true,
  },
  {
    key: PlayerApiKey.GamingUseCount,
    label: <Trans i18nKey="common.gamingUseTotal" />,
    sortable: true,
  },
  {
    key: PlayerApiKey.NonGamingUseCount,
    label: <Trans i18nKey="common.nonGamingUseTotal" />,
    sortable: true,
  },
  {
    key: PlayerApiKey.HarmObserved,
    label: <Trans i18nKey="common.actions" />,
  },
];

export const DEFAULT_HOURLY_SWEEP_MACROS = [
  {
    title: 'dashboardNew.completed',
    color: HourlySweepStatusColors.COMPLETED,
    status: HourlySweepStatus.COMPLETED,
    type: SweepType.Obligatory,
  },
  {
    title: 'dashboardNew.missed',
    color: HourlySweepStatusColors.MISSED,
    status: HourlySweepStatus.MISSED,
    type: SweepType.Obligatory,
  },
  {
    title: 'dashboardNew.pending',
    color: HourlySweepStatusColors.PENDING,
    status: HourlySweepStatus.PENDING,
    type: SweepType.Obligatory,
  },
  {
    title: 'dashboardNew.voluntary',
    color: HourlySweepStatusColors.VOLUNTARY,
    status: HourlySweepStatus.COMPLETED,
    type: SweepType.Voluntary,
  },
];

export const userMenuOption: UserMenuOption[] = [
  { label: 'userManagement.user.myAccount' },
  { label: 'userManagement.user.logout' },
];

export const numberPad: string[] = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];

export const languages: Language[] = [
  {
    label: 'English (UK)',
    value: 'en-uk',
    flagCode: GB,
  },
];

export enum IdPrefix {
  TABLET_LAYOUT = 'tablet-layout-image',
  DESKTOP_LAYOUT = 'desktop-layout-image',
  BUTTON = 'button',
}
